import classnames from 'classnames';
import React from 'react';

import { AssetV2 } from '../AssetV2';
import { PopupBuilderAssetContentSection } from '../contentTypes';
import { Div } from '../HTMLElement';
import { TextAlign } from '../interfaces';
import { PropsWithCustomComponent, VariantsController } from '../VariantsController';

export interface PopupBuilderAssetComponentProps extends PopupBuilderAssetContentSection {}

const PopupBuilderAssetComponent = ({ asset, options }: PopupBuilderAssetComponentProps) => {
  const textAlign = options?.alignment as TextAlign;

  return (
    <React.Fragment>
      {options?.enabled && (
        <Div className={classnames('popup-builder-asset-component', options.classes)} textAlign={textAlign}>
          <AssetV2 {...asset} fluid />
        </Div>
      )}
    </React.Fragment>
  );
};

export type PopupBuilderAssetComponentVariants = '';

const PopupBuilderAssetComponentController = (props: PropsWithCustomComponent<PopupBuilderAssetComponentProps>) => (
  <VariantsController<PopupBuilderAssetComponentProps, PopupBuilderAssetComponentVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: PopupBuilderAssetComponent,
      name: 'PopupBuilderAssetComponent',
    }}
  />
);
export { PopupBuilderAssetComponentController as PopupBuilderAssetComponent };
